<div class="pas-selector">
    <div
        class="pas-selector--back-to-branch-button"
        [class.pas-selector--back-to-branch-button_fullscreen]="fullscreen"
        (click)="handleBackToBranchClick($event)"
    >
        <img *ngIf="backToBranchClick && backToBranchClick.observers.length" src="./assets/images/arrow-menu_down.png" class="back-to-branch-button--icon">
        <img [src]="backToBranchIconSrc" class="branch-icon">
        <span>{{backToBranchLabel}}</span>
    </div>
    <div class="pas-selector-list">
        <div *ngIf="!rowData?.length" class="pas-selector__loading">
            <sc-icon icon="loading" size="2"></sc-icon>
        </div>
        <sc-list-set
            *ngIf="rowData?.length"
            [fullscreen]="fullscreen"
            [listMaxHeight]="listMaxHeight"
            [rowData]="rowData"
            [runAnimation]="runAnimation"
            [showFilter]="true"
            [title]="title"
            (onClick)="handleOnClick($event)">
            <ng-template let-row="row" let-index="index">
                <div [ngClass]="{'disabled': row.disabled, 'selected': selectedIndex === index}">
                    <div [ngClass]="{'list-row--pas-name': true, 'list-row--pas-name__disabled': row.disabled}">
                        {{getPasNumber(row)}} {{row.name}}
                    </div>
                    <div class="list-row--organizer-name">{{getPasNumber(row.organizer)}} {{row.organizer.name}}</div>
                    <div class="list-row--disabled-message" *ngIf="row.disabled">
                        <sc-icon class="warning-icon" icon="alert-elipse-copy"></sc-icon>
                        <span class="text">{{disabledMessage}}</span>
                    </div>
                </div>
            </ng-template>
        </sc-list-set>
    </div>
</div>
